'use strict';

function getRuleInfo(rule) {
  return {
    key: rule[0],
    isRuleEnd: !rule[1],
    nextRule: rule.slice(1),
  };
}

function executeObjectRule(data, result, rule) {
  const { key, isRuleEnd, nextRule } = getRuleInfo(rule);
  if (!(key in data)) {
    return result;
  }
  if (isRuleEnd) {
    result[key] = data[key];
    return result;
  }
  if (!result[key]) {
    result[key] = getEmptyCollection(data[key]);
  }
  result[key] = executeRule(data[key], result[key], nextRule);
  return result;
}

function executeArrayRule(data, result, rule) {
  for (let i = 0; i < data.length; i++) {
    const base = result[i] || getEmptyCollection(data[i]);
    const value = executeRule(data[i], base, rule);
    if (!Array.isArray(value)) {
      result[i] = { ...result[i], ...value };
      continue;
    }
    result[i] = result[i] || [];
    value.forEach((element, index) => {
      result[i][index] = result[i][index] || getEmptyCollection(element);
      result[i][index] = executeRule(element, result[i][index], rule);
    });
  }
  return result;
}

function executeRule(data, result, rule) {
  if (Array.isArray(data)) {
    return executeArrayRule(data, result, rule);
  }
  if (typeof data === 'object' && data !== undefined && data != null) {
    return executeObjectRule(data, result, rule);
  }
  return data;
}

function getEmptyCollection(data) {
  return Array.isArray(data) ? [] : {};
}

function pruneData(data, ...rawRules) {
  const rules = rawRules.map(rule =>
    Array.isArray(rule) ? rule : rule.split(':')
  );
  return rules.reduce(executeRule.bind(this, data), getEmptyCollection(data));
}

module.exports = { pruneData };
